import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Output,TemplateRef,
  ViewChild,
  EventEmitter,
  HostListener
} from '@angular/core';
import { CommonService } from '../../_service/common.service';
import { ComponentInteractionService } from '../../_service/component-interaction.service';
import { ServiceAdapterService } from '../../_service/service-adapter.service';
import { HttpResponse } from '../../_interface/http-response.interface';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  FormsModule,
  NgModel,
} from '@angular/forms';
import * as _ from 'lodash';
import { filter, mergeMap, pairwise } from 'rxjs/operators';
import filtervalue from '../../../assets/data/hul/filter/filtervalue.json';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyValue } from '@angular/common';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { FilterReqModel } from './models/filter.model';
import { of } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
})
export class FilterComponent implements OnInit {
  @Input() disableFilter = false;
  @Input() disableArr = [];
  @Input()  selectedValue: string;
  @Output() notificationEvent = new EventEmitter<any>();
  selectedFilterValue;
  reportFlag = false;
  trendsenterpriseFlag = false;
  trendsplantFlag = false;
  comparisonplantFlag = false;
  filterSelection : any = 'TYD';
  resetDate = true;
  filtervar = [];
  filterObj: any = {};
  filterObjSingle: any = {};
  modelJson = {
    climaticFilter: {},
    concept: {},
    assetFilter: {},
    categoryFilter: {},
    geoFilter: [],
    buildings: {},
    assets: [],
  };
  notiJson = {
    climaticFilter: {},
    concept: {},
    assetFilter: {},
    categoryFilter: {},
    geoFilter: [],
    buildings: {},
    assets: [],
  };
  btnStyle;
selectedShift = null;
  modelJsonDropdown = {
    climaticFilter: {},
    concept: {},
    assetFilter: {},
    categoryFilter: {},
    geoFilter: [],
    buildings: {},
    assets: [],
  };
  backendJson = [];
  locationArr = [];
  popUpContent;
  interactiveSubmitJson = {};
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 30;
  color = 'primary';
  loadingFlag = false;
  prevSelectedJson;
  dataExplorerFlag = false;
   datepickerIsOpen = false;
   showCard :boolean = false;
  buildingMultiSelectFlag = false;
  assetShowFlag = false;
  rulesPageBuildFlag = false;
  customDateDisableFlag = false;
  buildingName: string = 'vimal';
  minDate = new Date(2023,0,1);
  maxDate = new Date ();
  routeConfig = {
    dashboard: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
    },
    plantview: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    breakup: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
      tabs: [
        {
          url: 'enterprise',
          buildingMultiSelectFlag: true,
          level: 'buildingMultiselect',
        },
        {
          url: 'plant',
          buildingMultiSelectFlag: false,
          assetShowFlag: false,
          level: 'buildingLevel',
        },
      ],
    },
    trends: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
      tabs: [
        {
          url: 'enterprise',
          buildingMultiSelectFlag: true,
          level: 'buildingMultiselect',
        },
        {
          url: 'plant',
          buildingMultiSelectFlag: false,
          assetShowFlag: false,
          level: 'buildingLevel',
        },
      ],
    },
    kpi: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
      tabs: [
        {
          url: 'enterprise',
          buildingMultiSelectFlag: true,
          level: 'buildingMultiselect',
        },
        {
          url: 'plant',
          buildingMultiSelectFlag: false,
          assetShowFlag: false,
          level: 'buildingLevel',
        },
      ],
    },
    reports: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    comparison: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
      tabs: [
        {
          url: 'enterprise',
          buildingMultiSelectFlag: true,
          level: 'buildingMultiselect',
        },
        {
          url: 'plant',
          buildingMultiSelectFlag: false,
          assetShowFlag: false,
          level: 'buildingLevel',
        },
      ],
    },
    dadq: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
    },
    alerts: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    ipmvp: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    lossanalytics: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    finance: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    meterhierarchy: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    admin: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    tools: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    assetview: {
      buildingMultiSelectFlag: false,
      assetShowFlag: false,
      level: 'buildingLevel',
    },
    rules: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
    },
    ruless: {
      buildingMultiSelectFlag: true,
      assetShowFlag: false,
      level: 'buildingMultiselect',
    },
  };
  filterLevel = 'buildingLevel';
  filterContentJson = [];
  filterContentJson1 = [];
  startdateRange;
  enddateRange;
  filterMsg = true;
  filterArr: any[] = [
    { name: 'TYD', flag: true, disableFlag: false },
    { name: '1W', flag: false, disableFlag: false },
    { name: '1M', flag: false, disableFlag: false },
    { name: '3M', flag: false, disableFlag: false },
    { name: 'FY', flag: false, disableFlag: false }
  ];
  countBuild = 0;
  @ViewChild("contentmd") mdModalContent: TemplateRef<any>;
  filter: any;
 
  constructor(
    private serviceAdapterService: ServiceAdapterService,
    private componentInteractionService: ComponentInteractionService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private router: Router
  ) {}
  ngOnChanges(): void {
    this.customDateDisableFlag = false;
    if(this.disableArr.length > 0) {
      this.customDateDisableFlag = (this.disableArr.indexOf("CUSTOM") !== -1 || this.disableArr.indexOf("ALL") !== -1 ) ? true : false ;
      let defaultSelectionFlag = true;
      this.filterArr.forEach(filterObj=> {
        if(defaultSelectionFlag && this.disableArr.indexOf(filterObj['name']) ==-1 && this.filterMsg) {
          this.filterSelection = filterObj['name'];
          defaultSelectionFlag = false;
        }
      });
    }
    let dateRouter = this.router.url.toString().split('/')[2];
    if(dateRouter == 'analytics') {
      this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+7);
    } else {
      this.maxDate = new Date();
    }}

  ngOnInit(): void {
  
    if (this.disableArr)
      this.customDateDisableFlag = 
        (this.disableArr.indexOf('CUSTOM') !== -1 || this.disableArr.indexOf("ALL") !== -1) ? true : false;
    this.loadingFlag = true;
    this.getConfigBasedOnRoute(this.router.url);
    this.rulesPageBuildFlag = this.router.url ? true : false;
    this.serviceAdapterService
      .backendServiceCall<any>('getFilterContentJson', {
        page: 'filter-page',
        lang: 'en',
      }).subscribe((data) => {
        this.filterContentJson = data['data']['contentData'];
        sessionStorage.setItem(
          'contentJson',
          JSON.stringify(this.filterContentJson)
        );
        this.loadingFlag = false;
        this.getdropdownFilterData();
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.getConfigBasedOnRoute(event['url']);
        this.rulesPageBuildFlag =
          event['url'].indexOf('rules') != -1 ? true : false;
        this.rulesPageBuildFlag =
          event['url'].indexOf('ruless') != -1 ? true : false;
        if (this.routeConfig[event['url'].split('/')[1]]['level']) {
          let tabFilterLVLFlag = false;
          let tabArr = this.routeConfig[event['url'].split('/')[1]]['tabs'];
          let subTabObj;
          if (tabArr) {
            tabFilterLVLFlag = true;
            subTabObj = tabArr.find(
              (obj) => obj['url'] == event['url'].split('/')[2]
            );
          }
          if (
            this.filterLevel &&
            ((!tabFilterLVLFlag &&
              this.filterLevel ==
                this.routeConfig[event['url'].split('/')[1]]['level']) ||
              (tabFilterLVLFlag && this.filterLevel == subTabObj['level']))
          ) {
            //Climatic Filter single select based on building single select
            let climateZoneValues = _.map(
              this.modelJsonDropdown['climaticFilter']['value'],
              (json) => json['key']
            );
            if (true) {
              this.modelJson['climaticFilter'] = {
                name: this.modelJsonDropdown['climaticFilter']['name'],
                value: climateZoneValues,
              };
              this.modelJsonDropdown['climaticFilter']['allCheckbox'] = true;
            } else {
              //Building will be single select
              this.modelJson['climaticFilter'] = {
                name: this.modelJsonDropdown['climaticFilter']['name'],
                value: [climateZoneValues[0]],
              };
              this.modelJsonDropdown['climaticFilter']['allCheckbox'] = false;
            }

            this.onSubmitStaticFilter('fromcode');
          }
        } else {
          this.filterLevel = 'buildingLevel';
          //Climatic Filter single select based on building single select
          let climateZoneValues = _.map(
            this.modelJsonDropdown['climaticFilter']['value'],
            (json) => json['key']
          );
          if (true) {
            this.modelJson['climaticFilter'] = {
              name: this.modelJsonDropdown['climaticFilter']['name'],
              value: climateZoneValues,
            };
          } else {
            //Building will be single select
            this.modelJson['climaticFilter'] = {
              name: this.modelJsonDropdown['climaticFilter']['name'],
              value: climateZoneValues[0],
            };
          }
          this.onSubmitStaticFilter('fromcode');
        }
      });
  }

  getConfigBasedOnRoute(event) {
    let route = event.split('/')[1];
    if (route) {
      let routeObj = this.routeConfig[route];
      if (routeObj['tabs']) {
        let tabRoute = event.split('/')[2];
        this.buildingMultiSelectFlag = routeObj['tabs'].find(
          (obj) => obj['url'] == tabRoute
        )['buildingMultiSelectFlag'];
        this.filterLevel = routeObj['tabs'].find(
          (obj) => obj['url'] == tabRoute
        )['level'];
      } else {
        this.buildingMultiSelectFlag = routeObj['buildingMultiSelectFlag'];
        this.filterLevel = routeObj['level'];
        this.assetShowFlag = this.routeConfig[route]['assetShowFlag'];
      }
    } else {
      this.buildingMultiSelectFlag = false;
      this.assetShowFlag = false;
    }
  }

  getdropdownFilterData() {
    this.loadingFlag = true;
    this.serviceAdapterService
      .backendServiceCall<any>('getFilterValue')
      .subscribe(
        (data) => {
          this.loadingFlag = false;
          this.backendJson = data['data'];
          this.assignToModelJson();
        },
        (err) => {
          this.loadingFlag = false;
        },
        () => {
          this.loadingFlag = false;
        }
      );
  }
  notificationAlert(data) {
    this.serviceAdapterService
      .backendServiceCall<HttpResponse<'getnotification', ''>>('getnotification',
        data).subscribe((data) => {
          this.notificationEvent.emit(data);
        },(error) => {
        },() => {
        });
  }
 
  contentTransformationMethod1(content, type) {
    let contentArr = [];
    if (type === 'assets') {
      _.each(content, (json, index) => {
        let assContent = [];
        _.each(json.value, (value) => {
          let contentObj = {};
          contentObj['key'] = this.filterContentJson[value];
          contentObj['value'] = value;
          assContent.push(contentObj);
        });
        this.modelJsonDropdown['assets'][index].value = assContent;
      });
    } else {
      _.each(content, (value) => {
        let contentObj = {};
        contentObj['key'] = this.filterContentJson[value]
          ? this.filterContentJson[value]
          : value;
        contentObj['value'] = value;
        contentArr.push(contentObj);
      });
      this.modelJsonDropdown[type].value = contentArr;
    }
    if (
      type != 'geoFilter' &&
      type != 'assets' &&
      type != 'buildings' &&
      type != 'climaticFilter'
    ) {
      this.modelJson[type] = _.cloneDeep({
        name: this.modelJsonDropdown[type].name,
        value: content,
      });
    } else if (type == 'buildings') {

      if (this.buildingMultiSelectFlag) {
        this.modelJson['buildings'] = _.cloneDeep({
          name: this.modelJsonDropdown[type].name,
          value: content,
        });
      } else {
        //Building will be single select
        this.modelJson['buildings'] = _.cloneDeep({
          name: this.modelJsonDropdown[type].name,
          value: content[0],
        }); }

    } else if (type === 'climaticFilter') {
      if (true) {
        this.modelJson['climaticFilter'] = {
          name: this.modelJsonDropdown[type].name,
          value: content,
        };
      } else {
        //Building will be single select
        this.modelJson['climaticFilter'] = {
          name: this.modelJsonDropdown[type].name,
          value: [content[0]],
        };
      }
    }
  }

  assignToModelJson() {
    Object.keys(this.backendJson).map((key) => {
      if (key === 'location') this.locationArr = this.backendJson[key];
      else if (key === 'climateZone') {
        if (true) {
          this.modelJsonDropdown['climaticFilter'] = {
            name: key,
            allCheckbox: true,
            type: 'static',
            displayName: 'Climate Zone',
          };
        } else {
          this.modelJsonDropdown['climaticFilter'] = {
            name: key,
            allCheckbox: false,
            type: 'static',
            displayName: 'Climate Zone',
          };
        }
        this.contentTransformationMethod1(
          this.backendJson[key],
          'climaticFilter'
        );
      } else if (key === 'assetType') {
        this.modelJsonDropdown['assetFilter'] = {
          name: key,
          allCheckbox: true,
          type: 'static',
          displayName: 'Asset Type Filter',
        };
        this.contentTransformationMethod1(this.backendJson[key], 'assetFilter');
      } else if (key === 'energyType')
        this.modelJsonDropdown['energyFilter'] = '';
      else if (key === 'concept') {
        this.modelJsonDropdown['buildingFilter'] = ''; //Newly added changes for demo purpose Starts
       this.modelJsonDropdown['concept'] = {
          name: key,
          allCheckbox: true,
          type: 'static',
          displayName: 'Building Type Filter',
        };
        this.contentTransformationMethod1(this.backendJson[key], 'concept');
      } else {
        this.modelJsonDropdown[key] = {
          name: key,
          value: this.backendJson[key],
          allCheckbox: true,
          type: 'static',
          displayName: key,
        };
      }
    });
    this.assignLocationData1();
  }
  assignLocationData1() {
    let obj1 = [];
    Object.keys(this.locationArr[0]).forEach((key) => {
      obj1.push({ name: key, value: [], allCheckbox: true });
    });
    //Main loop
    this.locationArr.forEach((json) => {
      Object.keys(json).forEach((key) => {
        obj1.forEach((obj) => {
          if (obj['name'] == key) {
            if (json[key] != null && json[key] != 'null')
              obj['value'].push(json[key]);
          }
        });
      });
    });
    obj1.forEach((obj) => {
      //Assign unique values
      obj['value'] = [...new Set(obj['value'])];
    });

    this.modelJsonDropdown['geoFilter'] = obj1;
    this.modelJson['geoFilter'] = [];
    _.each(this.modelJsonDropdown['geoFilter'], (json) => {
      this.modelJson['geoFilter'] = this.modelJson['geoFilter'].concat(
        _.cloneDeep({ name: json['name'], value: json['value'] })
      );
    });
    this.onSubmitStaticFilter('fromcode'); //Default Call for submit
  }

  assignLocationData(name, value) {
   //Changes fo select All
    let selectedParam1Temp = _.sortBy(value);
    let paraDropdown2Temp = _.sortBy(
      _.filter(
        this.modelJsonDropdown['geoFilter'],
        (json) => json['name'] == name
      )[0]['value']
    );
    if (_.isEqual(selectedParam1Temp, paraDropdown2Temp)) {
      _.filter(
        this.modelJsonDropdown['geoFilter'],
        (json) => json['name'] == name
      )[0]['allCheckbox'] = true;
 this.modelJsonDropdown['concept']['allCheckbox'] = true; // 27/9/23 if continent checkbox select bu and building also needs to load with data
 this.modelJsonDropdown['buildings']['allCheckbox'] = true; // 27/9/23 if continent checkbox select bu and building also needs to load with data
let value = _.map(this.modelJsonDropdown['concept']['value'], 'value'); // 27/9/23 if continent checkbox select bu and building also needs to load with data
this.modelJson['concept']['value'] = _.cloneDeep(value); // 27/9/23 if continent checkbox select bu and building also needs to load with data
      
    } else {
      _.filter(
        this.modelJsonDropdown['geoFilter'],
        (json) => json['name'] == name
      )[0]['allCheckbox'] = false;
      this.modelJson['concept']['value'] = []; // 27/9/23 if continent unselect bu and building also needs to unselect
      this.modelJsonDropdown['concept']['allCheckbox'] = false; // 27/9/23 if continent unselect bu and building also needs to unselect
      this.modelJsonDropdown['buildings']['allCheckbox'] = false; // 27/9/23 if continent unselect bu and building also needs to unselect
      this.modelJson['buildings'] = []; // 27/9/23 if continent unselect bu and building also needs to unselect
    }
    //End of else part
    let loopFlag = false;
    _.each(this.modelJson['geoFilter'], (eachobj, index) => {
      if (name == eachobj['name']) loopFlag = true;
      if (loopFlag && name != eachobj['name']) {
        //If flag is true update values for all lower levels
        eachobj['value'] = [];
        _.each(this.locationArr, (indObj) => {
          if (value.indexOf(indObj[name]) != -1)
            eachobj['value'].push(indObj[eachobj['name']]);
        });
        eachobj['value'] = [...new Set(eachobj['value'])]; //selected values assigned
        this.modelJsonDropdown['geoFilter'][index]['value'] = [
          ...new Set(eachobj['value']),
        ]; ///////dropdown values assigned
        this.modelJsonDropdown['geoFilter'][index]['allCheckbox'] = true; //Lower levels all selected by default
      }
      this.modelJsonDropdown['geoFilter']['type'] = 'geo';
    });
    this.onSubmitStaticFilter('fromui'); //Default Call for submit && On change Geo Filter call to fetch data for Dynamic Filter
  }

  openPopUp(content) {
    this.popUpContent = content;
    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  onChangeStaticFilter(key, from) {
    //Changes fo select All
    let value = _.map(this.modelJsonDropdown[key]['value'], 'value');
    let selectedParam1Temp = _.sortBy(
      _.cloneDeep(this.modelJson[key]['value'])
    );
    let paraDropdown2Temp = _.sortBy(_.cloneDeep(value));
    if (_.isEqual(selectedParam1Temp, paraDropdown2Temp)) {
      this.modelJsonDropdown[key]['allCheckbox'] = true;
    } else {
      this.modelJsonDropdown[key]['allCheckbox'] = false;
    }
    this.onSubmitStaticFilter(from); //On change Static Filter call to call to fetch data for Dynamic Filter
    
  }

  onSubmitStaticFilter(from) {
   this.selectedFilterValue = this.filterSelection;
    let submitJson = {
      serviceId: 'getFilterDataBasedOnParameter',
      userId: 'admin',
      locale: 'en-US',
      requestType: 'building',
    };
    for (const [k, v] of Object.entries(this.modelJson)) {
      if (k != 'geoFilter' && k != 'assets') submitJson[k] = _.cloneDeep([v]);
      else {
        submitJson[k] = _.cloneDeep(v);
      }
    }
    submitJson['categoryFilter'] = [];
    submitJson['buildings'] = [];
    submitJson['assets'] = [];
    //Newly added changes for demo purpose Starts
    submitJson['buildingFilter'] = [];
    submitJson['energyFilter'] = [];
    //Newly added changes for demo purpose ends
    submitJson['climaticFilter'] = _.filter(
      submitJson['climaticFilter'],
      (json) => json.value.length > 0
    );
    submitJson['timefilter1'] = {
      fromDate: this.formatDate(this.startdateRange, 'date'),
      toDate: this.formatDate(this.enddateRange, 'date'),
      aggregration: this.selectedShift,
      intervalSelection: this.filterSelection
    };
    this.loadingFlag = true;
    if(submitJson['buildings'].length > 0 || submitJson['geoFilter'][1].value.length > 0 && submitJson['geoFilter'][0].value.length > 0 || submitJson['concept'][0].value.length > 0 ) { //if bu unselect building needs to be empty so call get stopped
      let filterSel = this.filterSelection
    this.serviceAdapterService
      .backendServiceCall<any>('getDynamicFilterBuildingValue', submitJson)
      .subscribe(
        (data) => {
          this.loadingFlag = false;
           let json = data['data'];
          this.filterSelection = filterSel;
          Object.keys(json).map((key) => {
            if (key == 'buildingName') {
              //Changing the building Name
              this.modelJsonDropdown['buildings'] = {
                name: key,
                allCheckbox: true,
                type: 'dynamic' ,
              };
              this.contentTransformationMethod1(json[key], 'buildings');
           
              let enterpriseFilterbuild = this.commonService.getEnterpriseFilter();
              let plantFilterbuild = this.commonService.getPlantFilter();
              if (this.interactiveSubmitJson['level']) {
                if (this.interactiveSubmitJson['level'] == this.filterLevel) {
                  if (this.buildingMultiSelectFlag) {
                    let multiBuildingSelect =
                      (enterpriseFilterbuild.length > 0 && from != "fromui")
                        ? enterpriseFilterbuild
                        : json[key];
                    this.modelJson['buildings'] = {
                      name: key,
                      value: multiBuildingSelect,
                    };
                  this.notificationAlert(this.modelJson);
                  } else {
                            let singleBuildingSelect =
                      plantFilterbuild.length > 0 
                        ? plantFilterbuild[0]
                        : json[key][0];
                    this.modelJson['buildings'] = {
                      name: key,
                      value: singleBuildingSelect,
                    };
                  }
                } else {
                  ///multiselect
                  if (this.buildingMultiSelectFlag) {
                    let multiBuildingSelect =
                      (enterpriseFilterbuild.length > 0 && from != "fromui")
                        ? enterpriseFilterbuild
                        : json[key];
                    this.modelJson['buildings'] = {
                      name: key,
                      value: multiBuildingSelect,
                    };
                   
                   this.notificationAlert(this.modelJson);
                  } else {
                    //for notification in alerticon need add [] in building value
                    let notiBuildingSelect = plantFilterbuild.length > 0 ? plantFilterbuild[0] : json[key][0];
                  this.notiJson['buildings'] = {
                    name: key,
                    value: notiBuildingSelect,
                  };
               this.notiJson['buildings'] = {...this.notiJson['buildings'],...{"value":[notiBuildingSelect]}}
                this.notificationAlert(this.notiJson);
                    //Building will be single select
                    let singleBuildingSelect =
                      plantFilterbuild.length > 0
                        ? plantFilterbuild[0]
                        : json[key][0];
                    this.modelJson['buildings'] = {
                      name: key,
                      value: singleBuildingSelect,
                    };
                  }
                }
              } else {
                if (this.buildingMultiSelectFlag) {
                  let multiBuildingSelect =
                    (enterpriseFilterbuild.length > 0 && from != "fromui") // 28/9/23 modified for if we select building it needs to reatin in all building and building count will get work
                      ? enterpriseFilterbuild
                      : json[key];
                  this.modelJson['buildings'] = {
                    name: key,
                    value: multiBuildingSelect,
                  };
                this.notificationAlert(this.modelJson);
                } else {
                   //for notification in alerticon need add [] in building value
                  let notiBuildingSelect = plantFilterbuild.length > 0 ? plantFilterbuild[0] : json[key][0];
                  this.notiJson['buildings'] = {
                    name: key,
                    value: notiBuildingSelect,
                  };
               this.notiJson['buildings'] = {...this.notiJson['buildings'],...{"value":[notiBuildingSelect]}}
                this.notificationAlert(this.notiJson);
                  //Building will be single select
                  let singleBuildingSelect = plantFilterbuild.length > 0 ? plantFilterbuild[0] : json[key][0];
                  this.modelJson['buildings'] = {
                    name: key,
                    value: singleBuildingSelect,
                  };
                }
              } //building retain issue fix ends
              if (this.router.url.toString().split('/')[1] == 'assetview') {
                this.modelJson['buildings'] = {
                  name: key,
                  value: 'SONIPAT',
                };
              } 
              if (this.assetShowFlag) {
                this.getAssetData(-2, from, '');
              } else {
                //Submit Data
                //Set Filter json for default cycle
                let submitJson = {};
                this.interactiveSubmitJson = {};
                for (const [k, v] of Object.entries(
                  _.cloneDeep(this.modelJson)
                )) {
                  if (k != 'geoFilter' && k != 'assets')
                    submitJson[k] = _.cloneDeep([v]);
                  else {
                    submitJson[k] = _.cloneDeep(v);
                  }
                }
                submitJson['categoryFilter'] = [];
                submitJson['assets'] = [];
                if (from != 'fromui') {
                  submitJson['buildingFilter'] = [];
                  submitJson['energyFilter'] = [];
                  submitJson = new FilterReqModel(submitJson); //if any filter is empty add as []
                  submitJson['level'] = this.filterLevel;
                  this.interactiveSubmitJson = submitJson;
                  let obj = {};
                  obj['modelJson'] = submitJson;
                  obj['modelJsonDropdown'] = this.modelJsonDropdown;
                  obj['timefilter1'] = {
                    fromDate: this.formatDate(this.startdateRange, 'date'),
                    toDate: this.formatDate(this.enddateRange, 'date'),
                    aggregration: this.selectedShift,
                    intervalSelection: this.filterSelection,
                  };
                  obj['selected'] = this.selectedValue;
                  this.componentInteractionService.setFilterJson(obj); //Default Trigger event
                  this.prevSelectedJson = _.cloneDeep(this.modelJson); //Retain previous selected if Filter closed without submitted
                  }
              }
            }
          });
        },
        (err) => {
          this.loadingFlag = false;
        },
        () => {
          this.loadingFlag = false;
        }
      );
    }
  }
  onChangeAsset(index, from, key) {
    //Changes fo select All
    let selectedParam1Temp = _.sortBy(
      _.cloneDeep(this.modelJson[key][index]['value'])
    );
    let value = _.map(this.modelJsonDropdown[key][index]['value'], 'value');
    let paraDropdown2Temp = _.sortBy(_.cloneDeep(value));
    if (_.isEqual(selectedParam1Temp, paraDropdown2Temp)) {
      this.modelJsonDropdown[key][index]['allCheckbox'] = true;
    } else {
      this.modelJsonDropdown[key][index]['allCheckbox'] = false;
    }
    if (from === 'dynamicfilteremoved') {
      //fromappliedfilter - From closing fro APPLIED FILTER section
      let submitJson = {};
      for (const [k, v] of Object.entries(_.cloneDeep(this.modelJson))) {
        if (k != 'geoFilter' && k != 'assets') submitJson[k] = _.cloneDeep([v]);
        else {
          submitJson[k] = _.cloneDeep(v);
        }
      }
      submitJson['categoryFilter'] = [];
      submitJson = new FilterReqModel(submitJson); //if any filter is empty add as []
      submitJson['level'] = this.filterLevel;
      let obj = {};
      obj['modelJson'] = submitJson;
      obj['modelJsonDropdown'] = this.modelJsonDropdown;
      this.componentInteractionService.setFilterJson(obj); //Default Trigger event
      this.prevSelectedJson = _.cloneDeep(this.modelJson); //Retain previous selected if Filter closed without submitted
    }
  }
  getAssetData(index, from, key) {
    if (
      (from == 'fromui' || from == 'dynamicfilteremoved') &&
      key != '' &&
      this.buildingMultiSelectFlag
    ) {
      //If not from UI Dont check for Select ALL
      //Changes fo select All
      let selectedParam1Temp = _.sortBy(
        _.cloneDeep(this.modelJson[key]['value'])
      );
      let value = _.map(this.modelJsonDropdown[key]['value'], 'value');
      let paraDropdown2Temp = _.sortBy(_.cloneDeep(value));
      if (_.isEqual(selectedParam1Temp, paraDropdown2Temp)) {
        this.modelJsonDropdown[key]['allCheckbox'] = true;
      } 
      else if(key == 'buildings') { // added on 27/9/23 if bu select pants needs to clear
       this.countBuild =  this.modelJson[key]['value'].length; // added on 27/9/23 if bu select pants needs to clear
        this.modelJsonDropdown[key]['allCheckbox'] = false;
      } 
      else {
         this.modelJsonDropdown['buildings']['allCheckbox'] = false; // 27/9/23 if bu unselect plant needs to get unselect
        this.modelJson['buildings'] = []; // 27/9/23 if bu unselect plant needs to get unselect
      }
     
    }
    //If assetTypeFilter is not selected then remove assets from UI and dont send assets call
    let assetFilterSelected = true;
    if (this.modelJson['assetFilter'].hasOwnProperty('value') &&
      this.modelJson['assetFilter']['value'] &&
      this.modelJson['assetFilter']['value'].length) {
      assetFilterSelected = true;
    } else {
      assetFilterSelected = false;
      this.modelJson['assets'] = [];
      this.modelJsonDropdown['assets'] = [];
    }
    if (key != 'assets' && this.assetShowFlag && assetFilterSelected) {
      //Dont call for last dropdown value && Normal Application
      let submitJsonAssets = {};
      for (const [k, v] of Object.entries(this.modelJson)) {
        if (k != 'geoFilter' && k != 'assets')
          submitJsonAssets[k] = _.cloneDeep([v]);
        else {
          submitJsonAssets[k] = _.cloneDeep(v);
        }
      }
      submitJsonAssets['categoryFilter'] = [];
      submitJsonAssets['assets'] = [];
      submitJsonAssets = new FilterReqModel(submitJsonAssets); //if any filter is empty add as []
      submitJsonAssets = {
        ...submitJsonAssets,
        serviceId: 'getFilterDataBasedOnParameter',
        userId: 'admin',
        locale: 'en-US',
        requestType: 'asset',
      };
      this.loadingFlag = true;
      this.serviceAdapterService.backendServiceCall<any>('getDynamicFilterAssetValue', submitJsonAssets)
        .subscribe((data) => {
            this.loadingFlag = false;
           
            let json = data['data'];
            Object.keys(json).map((key) => {
              this.modelJsonDropdown[key] = json[key];
              _.each(this.modelJsonDropdown[key], (inner, index) => {
                inner.aliasName = inner['name'] == 'rtu' ? 'RTU' : 'Lighting';
                this.modelJsonDropdown[key][index] = {
                  ...inner,
                  allCheckbox: true,
                };
              });
              this.modelJson[key] = [];
              _.each(this.modelJsonDropdown['assets'], (json) => {
                this.modelJson['assets'] = this.modelJson['assets'].concat(
                  _.cloneDeep({ name: json['name'], value: json['value'] })
                );
              });
              this.contentTransformationMethod1(
                this.modelJsonDropdown['assets'],
                'assets'
              );
            });
            //Set Filter json for default cycle
            let submitJson = {};
            for (const [k, v] of Object.entries(_.cloneDeep(this.modelJson))) {
              if (k != 'geoFilter' && k != 'assets')
                submitJson[k] = _.cloneDeep([v]);
               
              else {
                submitJson[k] = _.cloneDeep(v);
              }
              
            }
            submitJson['categoryFilter'] = [];
            if (from != 'fromui') {
              submitJson = new FilterReqModel(submitJson); //if any filter is empty add as []
              submitJson['level'] = this.filterLevel;
              let obj = {};
              obj['modelJson'] = submitJson;
              obj['modelJsonDropdown'] = this.modelJsonDropdown;
              this.componentInteractionService.setFilterJson(obj); //Default Trigger event
              this.prevSelectedJson = _.cloneDeep(this.modelJson); //Retain previous selected if Filter closed without submitted
              
            }
          },
          (err) => {
            this.loadingFlag = false;
          },
          () => {
            this.loadingFlag = false;
          }
        );
    } else {
      if (from == 'dynamicfilteremoved') {
        //fromappliedfilter - From closing fro APPLIED FILTER section
        let submitJson = {};
        for (const [k, v] of Object.entries(_.cloneDeep(this.modelJson))) {
          if (k != 'geoFilter' && k != 'assets')
            submitJson[k] = _.cloneDeep([v]);
          else {
            submitJson[k] = _.cloneDeep(v);
          }
        }
        submitJson['categoryFilter'] = [];
        submitJson = new FilterReqModel(submitJson); //if any filter is empty add as []
        submitJson['level'] = this.filterLevel;
        let obj = {};
        obj['modelJson'] = submitJson;
        obj['modelJsonDropdown'] = this.modelJsonDropdown;
        this.componentInteractionService.setFilterJson(obj); //Default Trigger event
        this.prevSelectedJson = _.cloneDeep(this.modelJson); //Retain previous selected if Filter closed without submitted
      }
    }
  }
  onSubmitFinalFilter(contentmd) {
  
    let submitJsonAssets = {};
    for (const [k, v] of Object.entries(this.modelJson)) {
      if (k != 'geoFilter' && k != 'assets')
        submitJsonAssets[k] = _.cloneDeep([v]);
      else {
        submitJsonAssets[k] = _.cloneDeep(v);
      }
    }
    submitJsonAssets['categoryFilter'] = [];
    if (!this.assetShowFlag) {
      //If not data explorer page, then assets empty
      submitJsonAssets['assets'] = [];
    }
    submitJsonAssets = new FilterReqModel(submitJsonAssets); //if any filter is empty add as []
    submitJsonAssets['level'] = this.filterLevel;
    let obj = {};
    obj['modelJson'] = submitJsonAssets;
    obj['modelJsonDropdown'] = this.modelJsonDropdown;
    obj['timefilter1'] = {
      fromDate: this.formatDate(this.startdateRange, 'date'),
      toDate: this.formatDate(this.enddateRange, 'date'),
      aggregration: this.selectedShift,
      intervalSelection: this.filterSelection,
    };
   obj['selected'] = this.selectedValue
    //if ntg is selected  in filter popup needs to show (27/9/23)
    if(obj['modelJson']['geoFilter'].length == 0 || obj['modelJson']['concept'].length == 0) {
      this.modalService.open(contentmd, { centered: true, size: 'md' });
      return
     
    } 
 //if ntg is selected  in filter popup needs to show (27/9/23) ends here//
    if (this.buildingMultiSelectFlag) 
      this.commonService.setEnterpriseFilter(
        obj['modelJson']['buildings'][0]['value']
      );
    //enterprise multifilter select
    else
      this.commonService.setPlantFilter(
        obj['modelJson']['buildings'][0]['value']
      ); //plant single filter select
    
      
      this.componentInteractionService.setFilterJson(obj);
    this.prevSelectedJson = _.cloneDeep(this.modelJson);
    this.notificationAlert(obj['modelJson']);
    //Retain previous selected if Filter closed without submitted
    this.modalService.dismissAll();
  }

  originalOrder = (a: any, b: any): number => {
    return 0;
  };
  onSelectAllGeoFilter(event, name, value, index) {
    if (event.target.checked) {
      this.modelJson['geoFilter'][index]['value'] = _.cloneDeep(
        this.modelJsonDropdown['geoFilter'][index]['value']
      );
    } else {
      this.modelJson['geoFilter'][index]['value'] = [];
    }
    this.assignLocationData(name, this.modelJson['geoFilter'][index]['value']); //Call for lower level value calculations
  }
  onSelectAllStaticFilter(event, key, type, index) {
    if (event.target.checked) {
      let value = _.map(this.modelJsonDropdown[key]['value'], 'value');
      this.modelJson[key]['value'] = _.cloneDeep(value);
        this.onSubmitStaticFilter('fromui');
    } 
 
  else {
      this.modelJson[key]['value'] = [];  
    }
    if (key == 'climaticFilter' || key == 'assetFilter')
      this.onSubmitStaticFilter('fromui');
    //On change Static Filter call to call to fetch data for Dynamic Filter
    else {
      this.getAssetData(index, 'fromui', key);
    }
    
  }
  onSelectAllAssets(event, key, index) {
    if (event.target.checked) {
      let value = _.map(this.modelJsonDropdown[key][index]['value'], 'value');
      this.modelJson[key][index]['value'] = _.cloneDeep(value);
    } else {
      this.modelJson[key][index]['value'] = [];
    }
  }
  convetModelDropdownJsontoModelJson() {
    //IN modeljson only name and value keys //Remove other keys lke allcheckbox,type
    for (var [k, v] of Object.entries(this.modelJsonDropdown)) {
      if (k != 'geoFilter' && k != 'assets') {
        if (v['type'] === 'static') {
        } else
          this.modelJson[k] = _.cloneDeep({
            name: v['name'],
            value: v['value'],
          });
      } else
        this.modelJson[k] = _.cloneDeep({ name: v['name'], value: v['value'] });
    }
  }

  filterChangedButNotSavedCheck() {
    //If Filter changed and not saved update filter to old value
    if (_.isEqual(this.prevSelectedJson, this.modelJson)) {
    } else {
      let submitJsonAssets = {};
      for (const [k, v] of Object.entries(this.modelJson)) {
        if (k != 'geoFilter' && k != 'assets')
          submitJsonAssets[k] = _.cloneDeep([v]);
        else {
          submitJsonAssets[k] = _.cloneDeep(v);
        }
      }
      submitJsonAssets['categoryFilter'] = [];
      submitJsonAssets = new FilterReqModel(submitJsonAssets); //if any filter is empty add as []
      submitJsonAssets['level'] = this.filterLevel;
      let obj = {};
      obj['modelJson'] = submitJsonAssets;
      obj['modelJsonDropdown'] = this.modelJsonDropdown;
      this.componentInteractionService.setFilterJson(obj);
    }
  }

  onIntervalChange(event) {
   this.startdateRange = '';
   this.enddateRange = '';
    this.filterMsg = true;
    this.filterSelection = event['name'];
    let submitJsonAssets = {};
    for (const [k, v] of Object.entries(this.modelJson)) {
      if (k != 'geoFilter' && k != 'assets')
        submitJsonAssets[k] = _.cloneDeep([v]);
      else {
        submitJsonAssets[k] = _.cloneDeep(v);
      }
    }
    submitJsonAssets['categoryFilter'] = [];
    if (!this.assetShowFlag) {
      //If not data explorer page, then assets empty
      submitJsonAssets['assets'] = [];
    }
    submitJsonAssets = new FilterReqModel(submitJsonAssets); //if any filter is empty add as []
    submitJsonAssets['level'] = this.filterLevel;
    let obj = {};
    obj['modelJson'] = submitJsonAssets;
    obj['modelJsonDropdown'] = this.modelJsonDropdown;
    obj['timefilter1'] = {
      fromDate: '',
      toDate: '',
      aggregration: '',
      intervalSelection: this.filterSelection,
    };
    obj['selected'] = this.selectedValue;
    this.componentInteractionService.setFilterJson(obj);
   
  }
  styleObject(): Object {
    if (
      this.filterSelection == '3M' ||
      (this.filterSelection == 'FY' && this.trendsplantFlag == true) ||
      this.trendsenterpriseFlag == true
    ) {
      return { cursor: 'none', opacity: '0.3' };
    }
    return {};
  }
 
  dateRangeChange() {
    this.filterMsg = false;
    this.filterSelection = null;
    this.startdateRange;
    this.enddateRange;
    let submitJsonAssets = {};
    for (const [k, v] of Object.entries(this.modelJson)) {
      if (k != 'geoFilter' && k != 'assets')
        submitJsonAssets[k] = _.cloneDeep([v]);
      else {
        submitJsonAssets[k] = _.cloneDeep(v);
      }
    }
    submitJsonAssets['categoryFilter'] = [];
    if (!this.assetShowFlag) {
      //If not data explorer page, then assets empty
      submitJsonAssets['assets'] = [];
    }
    submitJsonAssets = new FilterReqModel(submitJsonAssets); //if any filter is empty add as []
    submitJsonAssets['level'] = this.filterLevel;
    let obj = {};
    obj['modelJson'] = submitJsonAssets;
    obj['modelJsonDropdown'] = this.modelJsonDropdown;
    obj['timefilter1'] = {
      fromDate: this.formatDate(this.startdateRange, 'date'),
      toDate: this.formatDate(this.enddateRange, 'date'),
      aggregration: this.selectedShift,
      intervalSelection: '',
    };
    obj['selected'] = this.selectedValue;
    this.componentInteractionService.setFilterJson(obj);
  }
shiftWiseChange(){
console.log(this.selectedShift)
this.filterMsg = false;
    this.filterSelection = null;
    let submitJsonAssets = {};
    for (const [k, v] of Object.entries(this.modelJson)) {
      if (k != 'geoFilter' && k != 'assets')
        submitJsonAssets[k] = _.cloneDeep([v]);
      else {
        submitJsonAssets[k] = _.cloneDeep(v);
      }
    }
    submitJsonAssets['categoryFilter'] = [];
    
    submitJsonAssets = new FilterReqModel(submitJsonAssets); //if any filter is empty add as []
    submitJsonAssets['level'] = this.filterLevel;
    let obj = {};
    obj['modelJson'] = submitJsonAssets;
    obj['modelJsonDropdown'] = this.modelJsonDropdown;
    obj['timefilter1'] = {
      fromDate: this.formatDate(this.startdateRange, 'date'),
      toDate: this.formatDate(this.enddateRange, 'date'),
      aggregration: this.selectedShift,
      intervalSelection: '',
    };
    obj['selected'] = this.selectedValue;
    //console.log(obj)
    this.componentInteractionService.setFilterJson(obj);
    console.log(obj)
}
  formatDate(date, condition) {
    var result = '';
    if (date) {
      var d = date,
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      if (condition == 'date') result = [month, day, year].join('/');
      else if (condition == 'month') result = [year, month].join('/');
      else if (condition == 'year') result = year;
    }
    return result;
  }
 togglecard(event: MouseEvent){
    event.stopPropagation(); // Prevent immediate closing
    this.showCard = !this.showCard;
  }
  onCardClick(event: MouseEvent) {
      event.stopPropagation(); // Prevent closing when clicking inside the card
    }
   
    @HostListener('document:click')
    handleOutsideClick() {
      if (this.showCard) {
        this.showCard = false;
      }
    }
  
    onDatepickerOpen() {
      this.datepickerIsOpen = true;
    }
     onDatepickerClose() {
    this.datepickerIsOpen = false;
  }
  @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
      const target = event.target as HTMLElement;
   
      if (
        target.closest('.mat-datepicker-content') ||
        target.closest('.custom-dropdown')
      ) {
        return; // Do not close if clicking inside datepicker or dropdown
      }
   
      this.showCard = false;
    }
  ngOnDestroy(){
    this.componentInteractionService.setFilterJson("");
  }
}
